
const ALIGNMENTS = Object.freeze({
  LEFT: 'left',
  RIGHT: 'right'
});

export default ALIGNMENTS;
